var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVrWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "start_vr",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.82,18.83h0l-1.6,.5c-.1,0-.2,.1-.1,.3,0,.1,.1,.1,.1,.1l.6,.3c-1,1.5-2.5,2.5-4.2,2.9-1.8,.4-3.7,.1-5.3-.9-1.6-1-2.7-2.6-3.1-4.4-.4-1.8-.1-3.7,.9-5.3s2.6-2.7,4.4-3.1c1.8-.4,3.7-.1,5.3,.9,1.5,.9,2.5,2.4,3,4.1,.1,.3,.3,.4,.6,.3,.3-.1,.4-.3,.3-.6-.5-1.9-1.8-3.6-3.4-4.6-3.7-2.4-8.7-1.2-11,2.5-2.4,3.7-1.2,8.7,2.5,11,1.3,.8,2.8,1.2,4.3,1.2,.6,0,1.2-.1,1.8-.2,2-.5,3.7-1.6,4.9-3.4l.6,.3c.1,.1,.2,0,.3-.1v-.2l-.5-1.6c-.1,0-.3-.1-.4,0Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.62 17.63 12.12 13.63 11.22 13.63 13.12 18.53 14.22 18.53 16.02 13.63 15.12 13.63 13.62 17.63",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.42,15.13c0-.4-.1-.9-.5-1.2s-.9-.4-1.4-.4h-1.6v4.9h.9v-1.8h.6l1.2,1.8h1.1l-1.4-1.9c.1,0,.2-.1,.3-.1,.6-.2,.8-.7,.8-1.3Zm-1.2,.7c-.2,.1-.5,.2-.8,.2h-.6v-1.7h.6c.3,0,.6,0,.8,.2,.2,.2,.3,.4,.3,.7,.1,.2-.1,.5-.3,.6Z",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "square-2",
    "data-name": "square",
    width: 32,
    height: 32,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrWhite);
export default __webpack_public_path__ + "static/media/vr_white.6d8f23660614f8c54f9a97fe22546a60.svg";
export { ForwardRef as ReactComponent };